import React, { useEffect, useState, useContext, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { MailContext } from './Context';
import { Page } from '../../Models/Template';
import { Message } from '@microsoft/microsoft-graph-types';
import AppMailTable from './AppMailTable';

const MailInbox: Page = () => {
    const { FolderId } = useParams<{ FolderId: string }>();
    const { mails, GetMessages } = useContext(MailContext);
    const [inbox, setInbox] = useState<Message[] | undefined>([]);

    const fetchMessages = useCallback(async (FolderId: string | undefined) => {
        if (FolderId) {
            GetMessages(FolderId, 150);
        }
    }, [GetMessages]);

    useEffect(() => {
        fetchMessages(FolderId);
    }, [GetMessages, FolderId, fetchMessages]);

    useEffect(() => {
        if (mails && mails.length > 0) {
            setInbox(mails);
        } else {
            setInbox(undefined);
        }
    }, [mails]);

    return (
        <React.Fragment>
            <AppMailTable mails={inbox} />
        </React.Fragment>
    );
};

export default MailInbox;
